import "./style.css";
import { useTranslation } from 'react-i18next';
import background from "./img/background1.webp"
import { useEffect, useState } from "react";
import { changeLanguage } from 'i18next';
import { useNavigate } from "react-router-dom";

import {
    Button, NavHeader,
    NavHeaderActions,
    NavHeaderActionBtn,
} from "platformscode-react";

import { ArrowLeft02Icon, } from "@hugeicons/react-pro";

function App() {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    const navigate = useNavigate();

    useEffect(() => {
        document.documentElement.lang = currentLang;
        document.documentElement.dir = currentLang === 'ar' ? 'rtl' : 'ltr';
    }, [currentLang]);



    const Carddata = [
        {
            card: t("Consultations"),
            url: "./Consultation"
        },
        {
            card: t("Survey"),
            url: "./Survey"
        },
        {
            card: t("Electronic_sharing"),
            url: "./Electronic_sharing"
        },
        {
            card: t("TremsCondition.title"),
            url: "./conditions"
        },
        {
            card: t("faq.title"),
            url: "./FAQS"
        },
        {
            card: t("error"),
            url: "./error"
        },

        {
            card: t("CustomerCharter"),
            url: "./CustomerCharter"
        },
        {
            card: "حول التوظيف",
            url: "./Acareer"
        },
        {
            card: "Feedback",
            url: "./Feedback"
        },
        {
            card: "Feedbacksec",
            url: "./Feedbacksec"
        },
        {
            card: "Contactus",
            url: "./Contactus"
        },
        {
            card: "Career",
            url: "./Career"
        },


        {
            card: "header",
            url: "./Header"
        },


    ];


    const itemsPerPage = 20;
    const [currentPage, setCurrentPage] = useState(1);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const currentItems = Carddata.slice(startIndex, endIndex);
    const paginate = (pageNumbers) => setCurrentPage(pageNumbers);

    return (
        <>
            <NavHeader fullWidth divider >
                <NavHeaderActions>
                    <NavHeaderActionBtn
                        label={i18n.language === 'en' ? 'العربية' : 'English'}
                        onClick={() => changeLanguage(i18n.language === 'en' ? 'ar' : 'en')}>
                    </NavHeaderActionBtn>
                </NavHeaderActions>
            </NavHeader >
            < div className="page-title flex flex-col gap-[16px] lg:px-[80px] px-[var(--spacing-xl,16px)] bg-[var(--background-primary-25,#F7FDF9)] py-[45px] mb-[40px]"

                style={{
                    backgroundImage: `url(${background})`,
                    backgroundPosition: 'bottom center',
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover'
                }} >

                <h1 class="text-[var(--text-default,#161616)] text-[40px] leading-[60px] font-[600] tracking-[-0.96px]">  الصفحة الرئيسية</h1>
                {/* <p className="text-[var(--text-default,#161616)] text-[16px] font-[400] leading-[24px]  mb-[40px]">
                    {t("Electronic_sharing.description")}
                </p> */} </div >



            <main className="max-w-[1600px] mx-auto px-6">
                <div className="grid grid-cols-12 gap-[32px]">
                    <div className="col-span-12 xl:col-span-9">
                        <section>
                            <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
                                {currentItems.map((item, index) => (
                                    <div key={index} onClick={() => navigate(item.url)} className="card hover:bg-[#F9FAFB] relative flex flex-col justify-between rounded-[12px] border border-[#E5E7EB] p-4 h-full" style={{ border: '1px solid #D2D6DB' }}>
                                        {/* <div className="relative flex flex-col justify-between rounded-[12px] border border-[#E5E7EB] p-4 h-full"> */}
                                        <p className="text-[#1F2A37] text-[20px] sm:text-[24px] font-[600] leading-[24px] self-start m-4">
                                            {item.card}
                                        </p>
                                        <div className="mt-auto self-end">
                                            <Button
                                                className="bg-[#15803D] hover:bg-[#166534] w-[56px] h-[56px] sm:w-[64px] sm:h-[64px] md:w-[74px] md:h-[74px] p-0 rounded-[6px]"
                                                size="lg"
                                                variant="ghost"
                                                type="submit"
                                            >
                                                <ArrowLeft02Icon className="transition-transform ltr:rotate-180 text-white w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10" />
                                            </Button>
                                        </div>
                                        {/* </div> */}
                                    </div>
                                ))}
                            </div>
                        </section>
                    </div>
                </div>
            </main>


        </>
    );
}

export default App;